var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsubscribeMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1529",
    d: "M0-682.665H22v22H0Z",
    transform: "translate(0 682.665)",
    fill: "#39f8ba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unsubscribe_menu_icon",
    transform: "translate(-16 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5119",
    "data-name": "Rectangle 5119",
    transform: "translate(16 271)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1515",
    transform: "translate(16.998 954.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1517",
    transform: "translate(12.214 -670.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1519",
    d: "M0,0V1.842",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1521",
    transform: "translate(13.939 -669.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1523",
    d: "M0,0,0,.916",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1525",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1527",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1533",
    transform: "translate(10.46 9.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1535",
    d: "M-157.15-154.992v-.74a.874.874,0,0,0-.877-.87.874.874,0,0,0-.877.87c0-.233,0-.284,0-.517a.874.874,0,0,0-.877-.87.876.876,0,0,0-.847.641v-2.808a.874.874,0,0,0-.877-.87.874.874,0,0,0-.877.87v5.479",
    transform: "translate(162.384 160.154)",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1537",
    transform: "translate(8.899 13.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1539",
    d: "M-252.727-88.77v.183a2.451,2.451,0,0,1-.45,1.416,2.451,2.451,0,0,0-.45,1.416.126.126,0,0,1-.126.126h-5.2a.127.127,0,0,1-.126-.117,1.76,1.76,0,0,0-.712-1.218l-.172-.126a2.911,2.911,0,0,1-1.182-2.345v-1.2a1.084,1.084,0,0,1,1.08-1.089h.426",
    transform: "translate(261.145 91.726)",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1541",
    transform: "translate(15.694 13.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1543",
    d: "M0-16.353A.839.839,0,0,1,.784-16.9a.842.842,0,0,1,.839.845v.51",
    transform: "translate(0 16.897)",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1545",
    transform: "translate(12.267 6.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1547",
    d: "M-282.68,0V2.753a1.5,1.5,0,0,1-1.5,1.5H-292.1",
    transform: "translate(292.095)",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1549",
    transform: "translate(6.259 2.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1551",
    d: "M0,0H13.919a1.5,1.5,0,0,1,1.5,1.5v.449",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1553",
    transform: "translate(0.322 2.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1555",
    d: "M-302.619-232.263h-8.575a1.5,1.5,0,0,1-1.5-1.5V-238.5a1.5,1.5,0,0,1,1.5-1.5h2.918",
    transform: "translate(312.698 239.999)",
    fill: "none",
    stroke: "#39f8ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24000",
    "data-name": "Group 24000",
    transform: "translate(1.546 5.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23994",
    "data-name": "Group 23994",
    transform: "translate(0 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23990",
    "data-name": "Group 23990",
    transform: "translate(1.903 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M73.1,126.4a.3.3,0,0,1-.295-.295v-1.6a.295.295,0,0,1,.537-.167l.577.836-.006-.668a.295.295,0,0,1,.589-.006l.015,1.548a.326.326,0,0,1-.222.319.318.318,0,0,1-.356-.128l-.544-.788v.654A.3.3,0,0,1,73.1,126.4Z",
    transform: "translate(-72.81 -124.21)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M217.8,124.98a.663.663,0,0,0-.6-.956h-.467a.3.3,0,0,0-.295.295v1.609a.295.295,0,0,0,.295.295h0l.548,0a.727.727,0,0,0,.515-1.241Zm-.77-.366h.173a.076.076,0,0,1,0,.151h-.173Zm.255,1.018h-.255v-.278h.255a.139.139,0,0,1,0,.277Z",
    transform: "translate(-208.899 -124.024)",
    fill: "#39f8ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23991",
    "data-name": "Group 23991",
    transform: "translate(3.842 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M123.03,126.238a1.049,1.049,0,0,1-.779-.335.295.295,0,0,1,.437-.4.462.462,0,0,0,.343.142.186.186,0,0,0,.189-.106c0-.027-.05-.078-.151-.115-.252-.093-.477-.193-.486-.2a.3.3,0,0,1-.041-.022.6.6,0,0,1-.27-.6.659.659,0,0,1,.476-.533,1.019,1.019,0,0,1,.9.2.295.295,0,0,1-.377.453.442.442,0,0,0-.357-.086c-.036.011-.059.03-.062.053a.024.024,0,0,0,0,.013c.07.03.237.1.416.168a.7.7,0,0,1,.527.771A.757.757,0,0,1,123.03,126.238Z",
    transform: "translate(-122.175 -124.04)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23992",
    "data-name": "Group 23992",
    transform: "translate(5.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M168.826,126.221h0a.833.833,0,0,1-.455-.131.76.76,0,0,1-.388-.665v-1.107a.295.295,0,1,1,.589,0v1.107c0,.053.009.1.116.169a.25.25,0,0,0,.138.038h0a.288.288,0,0,0,.132-.029c.141-.071.141-.139.141-.179v-1.106a.295.295,0,1,1,.589,0v1.106a.774.774,0,0,1-.465.705.875.875,0,0,1-.4.092Z",
    transform: "translate(-167.981 -124.023)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23993",
    "data-name": "Group 23993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M25.192,126.221h0a.833.833,0,0,1-.455-.131.76.76,0,0,1-.388-.665v-1.107a.295.295,0,1,1,.589,0v1.107c0,.053.009.1.116.169a.25.25,0,0,0,.138.038h0a.288.288,0,0,0,.132-.029c.141-.071.141-.139.141-.179v-1.106a.295.295,0,0,1,.589,0v1.106a.774.774,0,0,1-.465.705A.875.875,0,0,1,25.192,126.221Z",
    transform: "translate(-24.347 -124.023)",
    fill: "#39f8ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23995",
    "data-name": "Group 23995",
    transform: "translate(15.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M392.648,125.982a.3.3,0,0,1-.295-.295v-1.595a.295.295,0,0,1,.589,0v1.595A.3.3,0,0,1,392.648,125.982Z",
    transform: "translate(-392.353 -123.798)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M456.662,125.564h-.371v-.2h.322a.295.295,0,1,0,0-.589h-.322v-.2h.371a.295.295,0,0,0,0-.589H456a.3.3,0,0,0-.295.295v1.58a.3.3,0,0,0,.295.295h.666a.295.295,0,1,0,0-.589Z",
    transform: "translate(-437.907 -123.977)",
    fill: "#39f8ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M413.776,124.749a.66.66,0,0,0-.595-.949h-.463a.3.3,0,0,0-.295.295v.734h0v.859a.295.295,0,0,0,.295.295h0l.543,0a.723.723,0,0,0,.514-1.233Zm-.763-.36h.169a.072.072,0,0,1,0,.145h-.169Zm.25,1h-.25v-.27h.25a.135.135,0,0,1,0,.269Z",
    transform: "translate(-396.329 -123.8)",
    fill: "#39f8ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23996",
    "data-name": "Group 23996",
    transform: "translate(11.406 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M301.41,125.983a1.092,1.092,0,1,1,.611-2,.295.295,0,1,1-.33.488.5.5,0,1,0-.281.92.346.346,0,0,0,.242-.084.34.34,0,0,0,.035-.036.295.295,0,1,1,.452.378.922.922,0,0,1-.728.33Z",
    transform: "translate(-300.318 -123.799)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23997",
    "data-name": "Group 23997",
    transform: "translate(9.609 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M257.877,126a1.042,1.042,0,0,1-.774-.333.295.295,0,0,1,.437-.4.455.455,0,0,0,.337.14.182.182,0,0,0,.185-.1c0-.022-.039-.071-.148-.111-.25-.092-.473-.191-.482-.2a.3.3,0,0,1-.041-.022.6.6,0,0,1-.268-.6.655.655,0,0,1,.473-.53,1.012,1.012,0,0,1,.9.2.295.295,0,0,1-.377.453.435.435,0,0,0-.351-.084c-.035.011-.057.029-.06.05a.023.023,0,0,0,0,.011c.07.03.235.1.411.166a.7.7,0,0,1,.524.767A.752.752,0,0,1,257.877,126Z",
    transform: "translate(-257.027 -123.812)",
    fill: "#39f8ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M352.967,125.134a.707.707,0,0,0,.39-.626.722.722,0,0,0-.732-.709H352.2a.295.295,0,0,0-.295.3v1.594a.295.295,0,0,0,.589,0v-.2l.346.394a.295.295,0,0,0,.442-.389Zm-.343-.746a.122.122,0,1,1,0,.24H352.5c0-.047,0-.09,0-.12s0-.07,0-.12Z",
    transform: "translate(-338.385 -123.799)",
    fill: "#39f8ba"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeMenuIcon);
export default __webpack_public_path__ + "static/media/unsubscribe_menu_icon.f9686b4d4496cd0b9630b0ef62339673.svg";
export { ForwardRef as ReactComponent };